/** @jsx React.DOM */
var React = require('react/addons')
var constants = require('../../helpers/constants')
var RemoteState = require('./remote-state')

var Footer = React.createClass({displayName: 'Footer',
  render: function() {
    return React.DOM.div({className: "container"}, 
      React.DOM.hr(null), 
      React.DOM.div({className: "row"}, 
        React.DOM.div({className: "col-sm-2"}, 
          React.DOM.p({className: "muted pull-left"}, 
            "RMC connection: ", RemoteState({network: constants.network})
          )
        )
      )
    )
  }
})

module.exports = Footer



//////////////////
// WEBPACK FOOTER
// ./src/partials/footer/index.jsx
// module id = 349
// module chunks = 0